import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterList',
})
export class FilterListPipe implements PipeTransform {
  transform(list: any[], searchText: string): any[] {
    if (!list) {
      return [];
    }

    if (!searchText) {
      return list;
    }

    searchText = searchText.toLocaleLowerCase();

    let filteredList = list.filter((item) => {
      if (item?.form_name && item?.form_name?.toLocaleLowerCase().includes(searchText)) {
        return item;
      } else if (item?.search_terms) {
        const terms = item.search_terms
          .toLowerCase()
          .split(',')
          .map((term) => term.trim());
        const matchesAnyTerm = terms.some((term) => term.includes(searchText)) || item?.name?.toLowerCase().includes(searchText);
        if (matchesAnyTerm) {
          return item;
        }
      } else {
        return item?.name?.toLowerCase().includes(searchText);
      }
    });

    return filteredList;
  }
}
